import React, { useEffect, useState } from "react"
import types from "prop-types"
import * as API from "services/api"
import { useCustomName } from "hooks"
import { DEPARTMENT_KEY } from "utils/customNameHelpers"
import { adminUserShowDepartmentMemberships } from "utils/propTypeShapes"
import LoadingIndicator from "shared/LoadingIndicator"
import { errorToast } from "shared/toast"
import DepartmentMembershipFacilities from "./DepartmentMembershipFacilities"

const groupDepartmentMembershipsByFacility = (memberships) => memberships.reduce((accumulator, membership) => {
  let membershipFacility = accumulator.find((facility) => facility.id === membership.department.facility.id)

  if (!membershipFacility) {
    membershipFacility = { ...membership.department.facility, departments: [] }
    accumulator.push(membershipFacility)
  }

  let membershipDepartment = membershipFacility.departments.find((department) => department.id === membership.department.id)

  if (!membershipDepartment) {
    membershipDepartment = { id: membership.department.id, name: membership.department.name, memberships: {} }
    membershipFacility.departments.push(membershipDepartment)
  }

  membershipDepartment.memberships[membership.segment] = { id: membership.id }

  return accumulator
}, [])

function LocationTab({ user }) {
  const { id: userId } = user

  const {
    nameInSentence: departmentNameInSentence,
    pluralName: departmentsName,
    pluralNameInSentence: departmentsNameInSentence,
  } = useCustomName(DEPARTMENT_KEY)

  const [loading, setLoading] = useState(true)
  const [departmentMembershipFacilities, setDepartmentMembershipFacilities] = useState([])

  useEffect(() => {
    const loadDepartmentMemberships = async () => {
      const response = await API.userDepartmentMemberships({ userId })

      if (response.ok) {
        setDepartmentMembershipFacilities(groupDepartmentMembershipsByFacility(response.data))
        setLoading(false)
      } else {
        errorToast(`Something went wrong.  Unable to load ${departmentNameInSentence} memberships.`)
      }
    }

    setLoading(true)
    loadDepartmentMemberships()
  }, [userId, departmentNameInSentence])

  return (
    <>
      <h1 className="tab-title">{departmentsName}</h1>
      {
        loading
          ? <LoadingIndicator textValue={`Loading user ${departmentsNameInSentence} ...`} />
          : <DepartmentMembershipFacilities departmentMembershipFacilities={departmentMembershipFacilities} />
      }
    </>
  )
}

LocationTab.propTypes = {
  user: types.shape({
    id: types.number,
    departmentMemberships: adminUserShowDepartmentMemberships,
    email: types.string,
    first_name: types.string,
    last_name: types.string,
    locked: types.bool,
    role: types.string,
  }).isRequired,
}

export default LocationTab
